import {
  AfterViewInit,
  Component, ElementRef, EventEmitter, OnChanges,
  OnInit, Output, SimpleChanges, ViewChild
} from '@angular/core';
import {Input} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {InsurableObjectService} from "../../../cross/user-insurance/api/user-added-insurance-api.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";


@Component({
  selector: 'app-pdf-view',
  templateUrl: './app-pdf-view.component.html',
  styleUrls: ['./app-pdf-view.component.scss']
})
export class AppPdfViewComponent implements OnInit, OnChanges {


  @Input() file!: any;
  @Input() pdfSrc: string | null = null;
  @Input() blob: string | null = null;
  @Input() base64: string | null = null;
  @Input() width: number | undefined;
  @Input() class: string | undefined;
  @Input() height: number | undefined;
  @Input() addedId: number | undefined;
  @Input() documentId: number | undefined;
  @Input() objectService: any | undefined;

  @ViewChild('pdfLink') pdfLinkRef!: ElementRef<HTMLAnchorElement>;
  @Output() handleNewWindowOpened: EventEmitter<boolean> = new EventEmitter<boolean>();
  initialized: boolean = false;

  constructor(protected insurableObjectService: InsurableObjectService, private sanitizer: DomSanitizer, private http: HttpClient) {
  }

  ngOnInit() {
    this.handleBase64();
    this.handleBlob();
    this.HandlePdfSrc();
  }

  getDocument() {
    this.getObservable().subscribe((res:string) => {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(res) as string;
      if (this.isMobileDevice()) {
        setTimeout(() => {
          this.handleNewWindowOpened.emit(true);
          this.pdfLinkRef.nativeElement.click();
          this.initialized = true;
        }, 1);
      }
    })
  }

  getObservable(): Observable<string> {
    if (this.addedId && this.documentId) {
      return this.objectService.getDocumentBinary(this.addedId, this.documentId);
    }
    return this.objectService.getDocumentBinary(this.documentId);
  }

  handleBlob() {
    if (this.blob) {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.blob) as string;
    }
  }

  handleBase64() {
    if (this.base64) {
      const dataUrl = `data:application/pdf;base64,${this.base64}`;
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(dataUrl) as string;
    }
  }

  HandlePdfSrc() {
    if (this.file?.pdfSrc) {
      this.pdfSrc = this.file.pdfSrc;
    }
  }

  isMobileDevice(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['file']) {
      this.HandlePdfSrc();
    }

    if (changes['blob']) {
      this.handleBlob();
    }

    if (changes['base64']) {
      this.handleBase64();
    }

    if (changes['addedInsuranceId'] || changes['documentId'] || changes['objectService']) {
      this.pdfSrc = null;
      this.getDocument();
    }
  }

}
